<div class="loader-overlay" *ngIf="loader.loading$ | async">
    <img src="assets/imgs/logos/odda/DarkBlue.svg" alt="Loading..." class="loader-logo" />
</div>